module.exports = __webpack_public_path__ + "static/media/1POLICY21.ec591bf0.jpg";